import SubHeader from "./SubHeader";
import "antd/dist/antd.css";
//RUN: new header component 16/04/2021
import "../shared/css/list-page.css";
import "../shared/css/headerpages.css";
import React, { useState, useEffect } from "react";
import { Drawer, Card, Table, Spin, PageHeader, Radio, Tabs, Button, Select, DatePicker, Space, Input, Skeleton, Form } from 'antd';
import { SaveOutlined, PlusOutlined, DeleteTwoTone } from '@ant-design/icons';
import * as _ from "lodash"; //
import moment from "moment";
import Dialog from '../shared/dialog';
import axios from "axios";
import { toInteger } from "lodash";
const titleTH = 'บันทึกข้อมูลประวัติการฉีดวัคซีน และ ประวัติการตรวจเชื้อ Covid-19';
const titleEN = 'Covid-19 vaccine and detection history'
const { TabPane } = Tabs;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TextArea } = Input;
const dateFormat = 'YYYY/MM/DD';
const weekFormat = 'MM/DD';
const monthFormat = 'YYYY/MM';
const newDate = Date.now();
const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];

const SecondBoardsTabs = () => {
  const [FinishAnswers, setFinishAnswer] = useState([]);
  const [AnswersCurrent, setAnswersCurrent] = useState([]);

  const [StatusEval, setStatusEval] = useState();
  const [underPrimery, setunderPrimery] = useState([]);
  const [EmpList, setEmpList] = useState([]);
  const [EmpListForSeacrh, setEmpListForSearch] = useState([]);
  const [assessorid, setassessor] = useState('');
  const [SectorList, setSectorList] = useState([]);
  const [spinner, setSpinner] = useState(true);
  const dialog = new Dialog();
  const init = async () => {
    setSpinner(
      true
    )

    const resultAns = await axios.post(process.env.REACT_APP_API_URL + "/api/getAnsConfirmLevel", {
      AssessorId: localStorage.getItem("EmpId"),
    })

    const resultGetPrimary = await axios.post(process.env.REACT_APP_API_URL + "/api/getUnderPrimaryByConfirmId", {
      empid: localStorage.getItem("EmpId"),
    })

    setFinishAnswer(
      resultAns.data[0].AnsForm
    )
    setStatusEval(
      resultAns.data[0].EvaluteStatus
    )
    setassessor(
      resultAns.data[0].assessor
    )
    setEmpListForSearch(
      resultGetPrimary.data[0].EmpList
    )
    setEmpList(
      resultGetPrimary.data[0].EmpList
    )
    setSectorList(
      resultGetPrimary.data[0].SectorList
    )

    setSpinner(
      false
    )
    //fetch emp list
    console.log('resultAns', resultAns)
    console.log('resultGetPrimary', resultGetPrimary)
    console.log('EmpList', EmpList)
    console.log('SectorList', SectorList)






  };

  const testarrayDupFunction = async (empid, assessor) => {
    //this.spinnerControl();

    // console.log("testarrayDupFunction");
    var tempDup = [];
    var tempDupFin = [];

    //RUN: ยัดใส่เป็น ToString ให้หมดเนื่องจากส่งไปsave กับ ส่งคืนมา มีค่าdatatype อิอัยยยยยยยยยย 16/04/2021

    tempDup = AnswersCurrent.filter((e) => {
      return (
        e.empid.toString() !== empid.toString() ||
        e.assessor.toString() !== assessorid.toString()
      );
    });

    tempDupFin = FinishAnswers.filter((e) => {
      return (
        e.EmpId.toString() !== empid.toString() ||
        e.Assessor.toString() !== assessorid.toString()
      );
    });


    await setAnswersCurrent(
      tempDup
    )

    await setFinishAnswer(tempDupFin)

  }

  const handleChange = (
    empid
  ) => async (event) => {
    // console.log('in change')
    //this.spinnerControl();
    console.log('event', event.target.value)


    console.log('go on event beginning', AnswersCurrent)
    var temp = [];
    temp = AnswersCurrent.filter((e) => {
      return (
        e.empid.toString() === empid.toString() &&
        e.assessor.toString() === assessorid.toString()
      );

    });

    console.log('AnswersCurrent on handle change', temp)


    if (temp.length == 0) {
      console.log(' in length 0 ')
      let newModel = {
        empid: empid,
        assessor: assessorid,
        Point: event.target.value
      }
      let newFinishInclude = {
        EmpId: empid,
        Assessor: assessorid,
        Point: event.target.value
      }
      await setAnswersCurrent(
        (prevState) => (
          [...prevState, newModel]
        )
      )
      await setFinishAnswer(
        (prevState) => (
          [...prevState, newFinishInclude]
        )
      )
    } else {

      await testarrayDupFunction(
        empid
      );

      let newModel = {
        empid: empid,
        assessor: assessorid,
        Point: event.target.value
      }
      let newFinishInclude = {
        EmpId: empid,
        Assessor: assessorid,
        Point: event.target.value
      }
      await setAnswersCurrent(
        (prevState) => (
          [...prevState, newModel]
        )
   
      )
      await setFinishAnswer(
        (prevState) => (
          [...prevState, newFinishInclude]
        )
      )


    }

    console.log('after events and logic have been done ', AnswersCurrent)
    console.log('ssd done ', FinishAnswers)


    //   this.AnsData.ansForm = this.testarrayDupFunction(
    //     empid,
    //     assessor
    //   );

    //   this.AnsData.ansForm.push({
    //     empid: empid,
    //     assessor: assessor,
    //     Point: value
    //   });
    // }

    // console.log('ansForm', this.AnsData.ansForm)


    // var five = this.AnsData.ansForm.filter(
    //   (e) => (e.Point == 5)
    // );

    // var four = this.AnsData.ansForm.filter(
    //   (e) => (e.Point == 4)
    // )
    // var three = this.AnsData.ansForm.filter(
    //   (e) => (e.Point == 3)
    // )
    // var two = this.AnsData.ansForm.filter(
    //   (e) => (e.Point == 2)
    // )
    // var one = this.AnsData.ansForm.filter(
    //   (e) => (e.Point == 1)
    // )
    // console.log('ionsss')
    // this.setState({ five: five, four: four, three: three, two: two, one: one })
    //this.spinnerControl();

    // console.log('this.state.ansDefault in count', this.state.ansDefault)
    // console.log('five', this.state.five)
    // console.log('four', this.state.four.length)
    // console.log('three', this.state.three.length)
    // console.log('two', this.state.two.length)
    // console.log('one', this.state.one.length)

  };
  const RefreshDefault = async () => {
    console.log('ddddddddddddddddd')
    EmpList.forEach((data) => {
       getDefaultScore(data.EmpId)
    })
  }
  const getSearchResults = async (query) => {
    //this.spinnerControl();
    console.log('query', query)
    const allData = EmpListForSeacrh
    let dataToShow = [];
    if (query == null) {
      dataToShow = allData
 

    } else {
      allData.forEach((item) => {
        // // console.log("item", item);
        const searchString = query;
        if (item.SectorId == searchString) {
          dataToShow.push(item);
        }
      });
    

    }

    // console.log('data to show: ', dataToShow);
    await setEmpList(
      dataToShow
    )
   await RefreshDefault()
    //this.spinnerControl();

  };
  const handleSectorChange = () => async (event) => {
    console.log('stepteptet handleSectorChange',)
    
    // tableDataTH.map((data,index)=>{
    //   console.log('lodlsaolsdolaosdl',data.StepPoint)
    // })


   await getSearchResults(event);
    // getDefaultScore();
    //this.spinnerControl();

    // console.log("handlePositionChange", value);
    // this.setState(
    //   {
    //     query: value,
    //   },
    //   () => {
    //     if (this.state.query && this.state.query.length > 0) {
    //       // console.log("this.state.query", this.state.query);
    //       this.getSearchResults(this.state.query);
    //     } else {
    //       this.setState({
    //         EmpListDatasource: this.state.results,
    //       });
    //     }
    //   }
    // );
    //this.spinnerControl();

  };

  const handleSaveDraft = () => {
    var empid;
    var assess;
    var point;
    console.log('in handlesavedraft', AnswersCurrent)
    // console.log("empid", empid);
    // console.log("assess", assess);
    // console.log("point", point);

    // console.log("ansSaveData", ansSaveData);

    fetch(process.env.REACT_APP_API_URL + "/api/saveFormFirstLevel", {
      method: "post",

      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },

      body: JSON.stringify({
        empid: localStorage.getItem('EmpId'),
        formid: "2",
        assessor: assessorid,
        buttonaction: "1",
        jsonans: AnswersCurrent,
      }),
    })
      .then((Response) => Response.json())
      .then((result) => {
        // console.log("save draft result: " + JSON.stringify(result));
        if (result.status == "404") {
          console.log('result', result)
          // alert("บันทึกไม่สำเร็จ");
          //RUN: ปรับการแจ้งเตือนให้เป็น pop up dialog 18/04/2021


          if (localStorage.getItem('Language') == 'TH') {
            dialog.WarningDialog('บันทึกร่างไม่สำเร็จ')
          } else {
            dialog.WarningDialog('Unable to Save Draft')
          }
        } else {

          if (localStorage.getItem('Language') == 'TH') {
            dialog.SuccessDialog('บันทึกร่างสำเร็จ', '/assessing-subordinate')
            localStorage.setItem('defaultActiveKey', 2)

          } else {
            dialog.SuccessDialog('Save Draft Success', '/assessing-subordinate')
            localStorage.setItem('defaultActiveKey', 2)
          }
        }


      });
  }


  // };
  const getDefaultScore = (empid) => {
    //this.spinnerControl();
    console.log(' in get default scores',FinishAnswers)
    var tempArray = [];
    tempArray = FinishAnswers.filter((e) => {
      return (
        e.EmpId == empid.toString() &&
        e.Assessor == assessorid.toString()
      );
    });
    // // console.log('empid temp: ', empid)
    // // console.log('assessor temp: ', assessor)
    // // console.log('ansDefault temp: ', this.state.ansDefault)
    // // console.log('getDefaultScore temp: ', tempArray)
    if (tempArray.length > 0) {
      //this.spinnerControl();
    console.log('ffff', typeof tempArray[0].Point)

      return parseInt(tempArray[0].Point);
    } else {
      //this.spinnerControl();

      return null;
    }


  }
  const columnsTH = [
    {
      title: 'รหัสบุคคลากร',
      dataIndex: 'EmpId',
      width: '0.1%',
    },
    {
      title: 'ชื่อ',
      dataIndex: 'FirstNameTH',
      width: '0.001%',
    },
    {
      title: 'นามสกุล',
      dataIndex: 'LastNameTH',
      width: '10%',

    },
    {
      title: 'ตำแหน่ง',
      dataIndex: 'PositionNameTH',
      width: '10%',
    },
    {
      title: 'สังกัด',
      dataIndex: 'SectorNameTH',
      width: '10%',
    },
    {
      title: 'คะแนนประเมินตนเอง',
      dataIndex: 'SumSelfEval',
      width: '10%',
    },
    {
      title: 'คะแนนหัวหน้าประเมิน',
      dataIndex: 'SumAssessorCalPoint',
      width: '10%',
    },
    {
      title: 'ระดับหัวหน้าประเมิน',
      dataIndex: 'StepPointAdmin',
      width: '10%',
    },
    {
      title: 'ระดับผลการปฎิบัติงาน',
      dataIndex: 'StepPoint',
      width: '10%',
    },
  ];

  let tableDataTH = [];
  {
    EmpList.map((data, index) => {
      tableDataTH.push(
        {
          key: index,
          EmpId: data.EmpId,
          FirstNameTH: data.FirstNameTH,
          LastNameTH: data.LastNameTH,
          PositionNameTH: data.PositionNameTH,
          SectorNameTH: data.SectorNameTH,
          SumSelfEval: data.SumSelfEval,
          SumAssessorCalPoint: data.SumAssessorCalPoint,
          StepPointAdmin: data.StepPointAdmin,
          StepPoint: (
   
            
            <div
            onChange={
              handleChange(
                data.EmpId,
              )
            }

            >
              {/* <div>เปิดในวันที่ 25/04/2022</div> */}
              
              <Radio.Group
                name="step-point"
                buttonStyle="solid"
                // defaultValue={5}
                // defaultValue={
                //     FinishAnswers.map( (dataFin,index)=>{
                //         let  pointtemp = null
                //          if(dataFin.EmpId.toString() == data.EmpId.toString()){  
                //            console.log('data dadada',dataFin.Point)
                //            pointtemp = dataFin.Point
                //            return {pointtemp}
                //          }else{ 
                //            console.log('ddddd',dataFin.Point)
                //            return {pointtemp}
                //          }
                //        })}

                value={getDefaultScore(data.EmpId)}
           
              // value={
              //   FinishAnswers.map((dataFin,index)=>{
              //    if(dataFin.EmpId.toString() == data.EmpId.toString()){  
              //      console.log('data dadada',dataFin.Point)
              //      return dataFin.Point
              //    }
              //  })}

              >
                <Radio.Button value={5}>5</Radio.Button>
                <Radio.Button value={4}>4</Radio.Button>
                <Radio.Button value={3}>3</Radio.Button>
                <Radio.Button value={2}>2</Radio.Button>
                <Radio.Button value={1}>1</Radio.Button>
              </Radio.Group>
            </div>
          )
        })
    })


  }




  const con = () => {
    console.log(' in change style')
    return 'green'
  }
  useEffect(() => {
    init();
  }, []);

  const newPostFormTH = () => (
    <div style={{ marginBlock: 15 }}>
      <Select
        placeholder="All"
        bordered
        style={{ width: '20em' }}

        defaultValue={"All"}
        onChange={handleSectorChange()}

      >
        <Option value={null}
          style={{ textAlign: 'center' }}

        > All </Option>
        {SectorList.map((position) => (
          <Option value={position.SectorId}
            style={{ color: con() }}

          >{position.SectorNameTH}</Option>
        ))}
      </Select>
      <Table
        className="tableVac"
        columns={columnsTH}
        dataSource={tableDataTH}
        pagination={false}
      />
      {/* <Form className="mb-3" style={{ margin: 15 }} onFinish={clickSubmit}>
        <Tabs style={{ marginLeft: 10, overflow: 'auto' }} defaultActiveKey="1" onChange={callback}
          tabBarExtraContent={<Form.Item>
            <Button type="primary"
              size="large"
              style={{ float: 'right' }}
              // onClick={clickSubmit} 
              htmlType="submit"
            >
              บันทึกข้อมูล
            </Button>
          </Form.Item>}
        >
          <TabPane tab="ข้อมูลการฉีดวัคซีน" key="1">

            <div style={{ textAlign: 'center' }}>
              <div style={{ marginBottom: '5%' }}>
                <h2>ท่านได้รับวัคซีนโควิด-19 แล้วหรือไม่ </h2> :

                <Radio.Group onChange={handleChange("VacState")} style={{ fontSize: '1em' }} value={VacState}>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'middle' }} value={0}>ได้รับแล้ว</Radio>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'middle' }} value={1}>ยังไม่ได้รับ</Radio>
                </Radio.Group>
              </div>
            </div>
            {VacState == 0 ?
              <div style={{ marginBottom: '5%' }}>
                <Button type="primary"
                  size="large"
                  style={{ margin: 15, float: 'right' }}
                  onClick={clickAdd}
                >
                  เพิ่มข้อมูล
                </Button>
                <div style={{ margin: 20, textAlign: '-webkit-center' }}>
                  <Table
                    className="tableVac"
                    columns={columnsTH}
                    dataSource={tableDataTH}
                    pagination={false}
                  />
                </div>
              </div>
              :
              <div>
                <div style={{ textAlign: 'center' }}>
                  <h2>ท่านยังไม่ได้รับวัคซีนด้วยเหตุผลใด </h2>
                </div>
                <Radio.Group onChange={handleChange("ReasonUnVac")}
                  style={{ fontSize: '1em', marginLeft: '18%' }} value={ReasonUnVac}>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'left' }} value={0}>
                    ไม่ประสงค์จะรับวัคซีน
                  </Radio>
                  <br></br>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'left' }} value={1}>
                    จองหรือลงทะเบียนรับวัคซีนแล้ว อยู่ระหว่างรอเข้ารับวัคซีน
                  </Radio>
                  <br></br>
                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'left' }} value={2}>
                    รอวัคซีนทางเลือก
                  </Radio>
                  <br></br>

                  <Radio style={{ fontSize: '1.5em', verticalAlign: 'left' }} value={3}>
                    อื่นๆ โปรดระบุ
                  </Radio>
                  <br></br>
                </Radio.Group>
                {ReasonUnVac == 3 ?
                  <div stlye={{ marginTop: '5%', marginBottom: '5%' }}>
                    <label>หมายเหตุ: </label>
                    <div style={{ textAlign: 'center', marginTop: '1%', marginBottom: '5%' }}>
                      <TextArea maxLength={100}
                        name="RemarkUnvac"
                        value={RemarkUnvac}
                        showCount
                        onChange={handleChange("RemarkUnvac")} />
                    </div>
                  </div>
                  :
                  <div style={{ textAlign: 'center', marginTop: '5%' }}>
                  </div>
                }
              </div>

            }

          </TabPane>
          <TabPane tab="ข้อมูลการตรวจเชื้อ" key="2">
            <div style={{ textAlign: 'center' }}>
              <div style={{ marginBottom: '2%' }}>
                <h2>การตรวจพบการติดเชื้อโควิด-19</h2>
             
              </div>
            </div>
            {DetectHistory == 0 ?
              <div style={{ textAlign: 'center' }}>
                <Button type="primary"
                  size="large"
                  style={{ margin: 15, float: 'right' }}
                  onClick={clickAddDetect}
                // icon={<PlusOutlined />}
                >
                  เพิ่มข้อมูล
                </Button>
                <div style={{ margin: 20, textAlign: '-webkit-center' }}>
                  <Table
                    className="tableVac"
                    columns={columnsCovidDetctHistoryTH}
                    dataSource={tableDetectHistoryTH}
                    pagination={false}
                  />
                </div>
              </div> :
              null
            }

          </TabPane>
        </Tabs>


      </Form> */}
      {/* */}

      <div style={{ textAlign: "center", marginTop: 15, marginBottom: 15 }}>

        <Button
          onClick={
            handleSaveDraft
          }
        >
          บันทึกร่าง
        </Button>
      </div>

    </div>
  )
  // console.log('asdasdasdasdasd',FinishAnswers)



  console.log('FinishAnswers', FinishAnswers)
  console.log('StatusEval', StatusEval)

  return (
    <Spin tip="Loading..." spinning={spinner} >

      <div>
        this is new page
        {newPostFormTH()}
      </div>
    </Spin>

  )
}
export default SecondBoardsTabs
